import { uniqueId } from 'lodash/fp';
import sidePanel from './sidePanel';

export default {
    busy: () => ({ type: 'UI_BUSY' }),
    free: () => ({ type: 'UI_FREE' }),
    activeLoaders: {
        start: (id) => ({ type: 'UI_LOADER_START', id }),
        stop: (id) => ({ type: 'UI_LOADER_STOP', id }),
    },
    isMobile: (isMobile) => ({ type: 'UI_IS_MOBILE', isMobile }),
    isDesktop: (isDesktop) => ({ type: 'UI_IS_DESKTOP', isDesktop }),
    dialog: {
        show: (callback, message, title, options = ['Ok'], otherProps = {}) => ({
            type: 'DIALOG_SHOW',
            dialog: {
                id: uniqueId('dialog-'),
                message,
                title,
                options,
                callback,
                otherProps,
            },
        }),
        hide: (id) => ({ type: 'DIALOG_HIDE', id }),
    },
    toast: {
        queue: (message) => ({ type: 'UI_TOAST_QUEUE', message }),
        set: (queue) => ({ type: 'UI_TOASTS_SET', queue }),
        clear: () => ({ type: 'UI_TOASTS_SET', queue: [] }),
        done: (message) => ({ type: 'UI_TOAST_DONE', message }),
    },
    sidePanel,
    navigation: (pathname) => ({ type: 'UI_NAVIGATION' , pathname}),
};
